var _MoreVertical;
import MoreVertical from '@crehana/compass.icons.outline/MoreVertical';
import { TextTag } from '@crehana/compass.ui';
import { useTranslation } from '@crehana/i18n';
import { COLLAPSE_PERMISSIONS_ROLE } from "../i18n";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var HeaderCollapse = function HeaderCollapse(_ref) {
  var name = _ref.name,
    permissions = _ref.permissions;
  var _useTranslation = useTranslation(COLLAPSE_PERMISSIONS_ROLE),
    t = _useTranslation.t;
  var writingTotal = permissions.filter(function (f) {
    return f.can_be_edited;
  }).length || 0;
  var viewerTotal = permissions.filter(function (f) {
    return f.can_be_viewed;
  }).length || 0;
  var totalPermissions = permissions.length;
  var selectedTotal = writingTotal + viewerTotal;
  var maxTotal = selectedTotal > totalPermissions ? totalPermissions : selectedTotal;
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-flex tw-items-center tw-flex-grow",
    children: [/*#__PURE__*/_jsx("span", {
      className: "tw-flex-grow tw-font-subtitle5",
      children: name
    }), /*#__PURE__*/_jsx(TextTag, {
      label: t('STEP_3_TOOLS_TAG', {
        interpolation: {
          total: maxTotal
        }
      }),
      className: "tw-font-body5 tw-font-normal tw-mr-2"
    }), _MoreVertical || (_MoreVertical = /*#__PURE__*/_jsx(MoreVertical, {
      className: "tw-ml-0.8",
      size: 20
    }))]
  });
};
export default HeaderCollapse;